import { Navigate } from "react-router-dom";

import APPS from "constants/applications";
import { useIsAuthenticated } from "common/authentication";
import AccountLogin from "common/account/login";
import LoadingIndicator from "common/core/loading_indicator";
import { useQuery } from "util/graphql";

import ActivationReferral from "./index_query.graphql";

export function ReferralActivation() {
  const { data } = useQuery(ActivationReferral, {});
  const isAuthenticated = useIsAuthenticated();

  if (!data) {
    return <LoadingIndicator />;
  }

  const { referralInfo } = data.viewer;

  // TODO BIZ-7101 this check is gracefully handled in the referral handler
  // keeping this just to reference the referralInfo once until we start using it
  // later
  if (!referralInfo) {
    return <Navigate to="/" />;
  }
  if (isAuthenticated) {
    // TODO BIZ-7101 handle telling the backend to look at the cookie
    // to apply the easylink to the logged in account
    // Will look at combining this with the above depending on the approach
    // we go with.
    return <Navigate to="/" />;
  }

  return <AccountLogin signUpPortal={APPS.TITLE_AGENCY} entry={APPS.TITLE_AGENCY} />;
}
